var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"std-page-container",class:[`std-page-container--${_vm.type}`]},[_vm._t("title"),_c('div',{staticClass:"std-page-container__body"},[_vm._t("content")],2),_c('div',{staticClass:"std-page-container__footer"},[_vm._t("footer")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }